// src/services/api.js
// Capa de servicios centralizada para todas las llamadas al backend SAP.
// - Inyecta automáticamente el token de sesión en cada request.
// - Maneja de forma global el 401 (sesión expirada): limpia la sesión y
//   redirige al login una sola vez.
import axios from 'axios';

const api = axios.create({
  // En desarrollo, las peticiones a /api son redirigidas por src/setupProxy.js
  // hacia el servidor SAP (SAP_PROXY_TARGET).
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// --- REQUEST: agrega el token de sesión si existe ---
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sap_session_token');
  if (token) {
    config.headers['Authorization'] = token;
  }
  return config;
});

// --- RESPONSE: manejo global de sesión expirada (401) ---
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // El endpoint de login devuelve 401 con credenciales inválidas;
    // en ese caso NO debemos limpiar/redirigir (el formulario muestra el error).
    const isLoginRequest = error.config?.url?.includes('/login');

    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('sap_session_token');
      localStorage.removeItem('usuario');
      localStorage.removeItem('sap_session_expira');
      // Bandera para que Login avise al usuario que la sesión expiró.
      sessionStorage.setItem('sesion_expirada', '1');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
